/** The localStorage key for the analytics consent choice. Kept in its own leaf
 *  module so both `consent.ts` and `gtm.ts` can import it without forming a
 *  circular dependency between them. */
export const CONSENT_KEY = "dec_consent_analytics";
